import { render, staticRenderFns } from "./Club.vue?vue&type=template&id=94bfc12c&scoped=true&"
import script from "./Club.vue?vue&type=script&lang=js&"
export * from "./Club.vue?vue&type=script&lang=js&"
import style0 from "./Club.vue?vue&type=style&index=0&id=94bfc12c&prod&lang=css&"
import style1 from "./Club.vue?vue&type=style&index=1&id=94bfc12c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bfc12c",
  null
  
)

export default component.exports